module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-thumb-index__item",
    class: _vm.append_class.item
  }, [_c('a', {
    staticClass: "c-thumb-index__link",
    class: _vm.class_link,
    attrs: {
      "href": _vm.link
    }
  }, [_c('div', {
    staticClass: "c-thumb-index__thumb"
  }, [_c('img', {
    staticClass: "u-sz-w100",
    class: _vm.append_class.image,
    attrs: {
      "src": _vm.item.thumb,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.has_type) ? _c('span', {
    staticClass: "c-thumb-index__badge"
  }, [_vm._v(_vm._s(_vm.item.type))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-thumb-index__title",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c706c8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/thumb-index/thumb-index-item.vue
// module id = 52
// module chunks = 0